
import { z } from "zod";

export const InspectionRescheduleReasonValues = ["CREW_DID_NOT_SHOW", "FINAL_INSPECTION_FAILED", "INSPECTOR_DID_NOT_SHOW", "REQUESTED_BY_AHJ", "REQUESTED_BY_HOMEOWNER", "REQUESTED_BY_REMI", "STANDARD_SCHEDULING"] as const;
export const InspectionRescheduleReasonSchema = z.enum(InspectionRescheduleReasonValues);
export const InspectionRescheduleReason = InspectionRescheduleReasonSchema.enum;
export type InspectionRescheduleReason = (typeof InspectionRescheduleReasonValues)[number];
export const InspectionRescheduleReasonDisplayNames = { "CREW_DID_NOT_SHOW": "Crew did not show",
"FINAL_INSPECTION_FAILED": "Final inspection failed",
"INSPECTOR_DID_NOT_SHOW": "Inspector did not show",
"REQUESTED_BY_AHJ": "Requested by AHJ",
"REQUESTED_BY_HOMEOWNER": "Requested by homeowner",
"REQUESTED_BY_REMI": "Requested by Remi",
"STANDARD_SCHEDULING": "Standard scheduling", } satisfies Record<InspectionRescheduleReason, string>;
